import * as actions from 'actions';
import byIdMaker from 'reducersMakers/byIdMaker';

export default byIdMaker({
  fetchSuccessTypes: [
    actions.FEED_QUESTIONNAIRES_RECEIVED
  ],
  updateSuccessTypes: [
   actions.FEED_QUESTIONNAIRE_UPDATE
  ],
  entityType: 'questionnaires',
  updateKey: 'feedQuestionnairesIds'
});



/** WEBPACK FOOTER **
 ** ./src/members/state/feed/feedQuestionnaires/byId/reducer.js
 **/